// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"c6b8a4ad","593":"e9e64bc5"}[chunkId] + ".chunk.js";
};